module.exports = __webpack_public_path__ + "img/139.7b1baccf.jpg";